import React from "react";
import {TCompanyBioProps} from "mapx-components/Cards/CandidateCard/CompanyBio/types";
import Markdown from "react-markdown";
import styles from "./styles.module.scss";

const CompanyBio = ({bio}: TCompanyBioProps) => {
	return (
		<div className={styles.wrapper} data-testid="bio-wrapper-id">
			<div className={styles.title}>Bio</div>

			<div className={styles.description} data-testid="markdown-id">
				<Markdown>{bio}</Markdown>
			</div>
		</div>
	);
};

export default CompanyBio;
